// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from '../ContentComponentItem.fragment.generated';
import { LinkFragmentDoc } from '../../index.generated';
export const ComponentSideBySideImageFragmentDoc = gql`
    fragment componentSideBySideImage on ComponentSideBySideImage {
  image {
    ...imageLarge
  }
  caption
  content {
    ...contentComponentItem
  }
  link {
    ...link
  }
}
    ${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}
${LinkFragmentDoc}`;